import ApiService from '@/services/api.service'

export default {

    async createFavorite (projectId, keywordId, urlId, note = null) {
        return ApiService.post('/v2/favorites', {
            project_id: projectId,
            keyword_id : keywordId,
            url_id: urlId ,
            note: note
        })
    },

    async readFavorites (projectId) {
        return ApiService.get('/v2/favorites', {
            'per-page': 1000,
            filter: {project_id: projectId}
        })
    },

    async updateFavorite (id, note) {
        return ApiService.patch(`/v2/favorites/${id}`, {note: note})
    },

    async deleteFavoriteById (id) {
        return ApiService.delete('/v2/favorites', {
            filter: {id: id}
        })
    },

    async deleteFavoriteByUrl (projectId, url) {
        return ApiService.delete('/v2/favorites', {
            filter: {project_id: projectId, 'url.url': url}
        })
    },

}